function publicHttpsUrl(value) {
  if (typeof value !== "string") return "";
  const href = value.trim();
  if (!/^https:\/\/[^/\\?#]+/i.test(href) || href.includes("\\")) return "";
  if ([...href].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return "";
  try {
    const url = new URL(href);
    return url.protocol === "https:" && url.hostname && !url.username && !url.password ? href : "";
  } catch {
    return "";
  }
}

export function getAppInformationLinks(configuration = {
  privacyPolicyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL,
  supportUrl: process.env.REACT_APP_SUPPORT_URL,
  accountDeletionUrl: process.env.REACT_APP_ACCOUNT_DELETION_URL,
}) {
  return [
    ["privacy", "Privacy policy", configuration.privacyPolicyUrl],
    ["support", "Support", configuration.supportUrl],
    ["account-deletion", "Account deletion", configuration.accountDeletionUrl],
  ].flatMap(([id, label, value]) => {
    const href = publicHttpsUrl(value);
    return href ? [{ id, label, href }] : [];
  });
}
